import React, { useEffect, useState, useRef, useContext } from "react";
import "./index.css";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ErrorMessage, Formik, Form as FormikForm } from "formik";
import { toast } from "react-toastify";
import axios from "../../axios";
import { API_CALL_URL_PRIVATE, DOMAIN_URL } from "../../constants/compensate";
import Texterror from "../Texterror";
import { WorkDriverGraphValidation } from "../../utils/validator";
import { useSelector } from "react-redux";
import MultiSelectTwo from "../MultiSelectCustom/MultiSelectTwo";
import { ThemeContext } from "../../providers/ThemeProvider";

function EditFacilityForm() {
  const { ID } = useParams();
  const navigate = useNavigate();
  const customer_code = useSelector((state) => state.compensate.customerCode);
  const [isLoading, setIsLoading] = useState(false);
  const [isInitialData, setISInitialData] = useState(false);
  const [TimezoneOptions, setTimezoneOptions] = useState([]);
  const [theme, setTheme] = useContext(ThemeContext);
  const [initialValues, setInitialValues] = useState({
    customer_code: "",
    field_name: "",
    notes: "",
    display_on_workdriver: "",
    display_on_trends: "",
  });
  const parentRef = useRef(null);
  const [costCenterList, setCostCenterList] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);

  useEffect(() => {
    const getInitalData = async () => {

      const resp = await axios.post(
        `${API_CALL_URL_PRIVATE}/workdriverGraphField/view`,
        { _id: ID, customer_code: customer_code }
      );
      const Detail = resp.data?.data?.field_details;
      setInitialValues((prev) => {
        return {
          ...prev,
          customer_code: Detail?.customer_code,
          notes: Detail?.notes,
          field_name: Detail?.field_name,
          display_on_workdriver: Detail?.display_on_workdriver,
          display_on_trends: Detail?.display_on_trends,
        };
      });

      setISInitialData(true);
    };
    getInitalData();
  }, [ID]);

  const onSubmit = (values, onSubmittingProps) => {
    console.log("form Values", values);
    formSubmit(values);
    // setTimeout(() => {
    //   onSubmittingProps.setSubmitting(false);
    // }, [2000]);
  };
  const formSubmit = async (values) => {
    console.log("cal", values);
    

    const category_ids = selectedCategories
      .map((category) => category.value)
      .join(",");

    var formData = {
      _id: ID,
      field_name: values.field_name,
      customer_code: customer_code,
      category_ids: category_ids,
      notes: values.notes,
      display_on_workdriver: values?.display_on_workdriver,
      display_on_trends: values?.display_on_trends,
    };
    try {
      setIsLoading(true);
      const resp = await axios.post(
        `${API_CALL_URL_PRIVATE}/workdriverGraphField/create`,
        formData
      );
      console.log(resp);
      toast.success(resp?.data.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
      });
      navigate("/admin/workdriver-graph");
    } catch (error) {
      toast.error(error.response.data.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
      });

      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };


      // const getCustomerDetailList = async () => {
      //   try {
      //     const resp = await axios.post(
      //       `${API_CALL_URL_PRIVATE}/costcentercategory/distinctList`,
      //       {
      //         customer_code: parseInt(customer_code),
      //       }
      //     );

      //     const Data = resp?.data?.data?.data;

      //     const drop_facility = Data?.map((e) => {
      //       return {
      //         label: e?.cost_center_category,
      //         value: e?.cost_center_category_id,
      //       };
      //     });
      //     setCostCenterList([...drop_facility]);
      //     return drop_facility;
      //   } catch (error) {
      //     console.log(error);
      //   }
      // };

     const handleCheckboxDropChange = (selected) => {
      console.log("selected", selected);
       setSelectedCategories(selected);
     };
     

     console.log("cosCe", costCenterList);

  return (
    <>
      {isInitialData ? (
        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
          validate={WorkDriverGraphValidation}
          enableReinitialize
          validateOnChange
        >
          {(formik) => (
            <div className="main-panel">
              {console.log(formik)}
              <div className="content-wrapper">
                <div className="page-header">
                  <h3 className="page-title">
                    <a href="#" className="badge badge-dark"></a>
                  </h3>
                  <div className></div>
                </div>
                <div className="row">
                  <div class="col-12 grid-margin stretch-card">
                    <div class="card">
                      <div class="card-body">
                        <div className="d-flex justify-content-between">
                          <Link
                            to={`/admin/workdriver-graph`}
                            className="f-14 white-text-dark-mode"
                          >
                            <FontAwesomeIcon icon="fa-solid fa-arrow-left " />{" "}
                            Back
                          </Link>
                          <h4 class="card-title">
                            Edit Workdriver/Trends Graph (Pay Period)
                          </h4>
                          <div></div>
                        </div>

                        <FormikForm className="forms-sample">
                          <div class="row">
                            <Form.Group
                              className="col-md-6 mb-3"
                              controlId="exampleForm.c_name"
                            >
                              <Form.Label>
                                Field Name
                                <span style={{ color: "red" }}>
                                  &nbsp;*
                                </span>{" "}
                                (Accept small letters, numbers, underscores)
                              </Form.Label>
                              <Form.Control
                                type="text"
                                placeholder=""
                                readOnly
                                name="field_name"
                                {...formik.getFieldProps("field_name")}
                              />
                              <ErrorMessage
                                name="field_name"
                                component={Texterror}
                              />
                            </Form.Group>

                            <Form.Group
                              className="col-md-6 mb-3"
                              controlId="exampleForm.c_name"
                            >
                              <Form.Label>Note</Form.Label>
                              <Form.Control
                                as="textarea"
                                rows={3}
                                placeholder=""
                                name="notes"
                                {...formik.getFieldProps("notes")}
                              />
                              <ErrorMessage
                                name="notes"
                                component={Texterror}
                              />
                            </Form.Group>

                            <Form.Group
                              className="col-md-2 my-3"
                              controlId="exampleForm.c_email"
                            >
                              <div class="checkbox-item">
                                <input
                                  type="checkbox"
                                  class="custom-checkbox"
                                  checked={
                                    formik.values.display_on_workdriver === 1
                                      ? true
                                      : false
                                  }
                                  onChange={(p) => {
                                    if (p.target.checked) {
                                      formik.setFieldValue(
                                        "display_on_workdriver",
                                        parseInt("1")
                                      );
                                    } else {
                                      formik.setFieldValue(
                                        "display_on_workdriver",
                                        parseInt("0")
                                      );
                                    }
                                  }}
                                />
                                Display On WorkDriver
                              </div>
                              {/* <ErrorMessage
                              name="customer_address"
                              component={Texterror}
                            /> */}
                            </Form.Group>

                            <Form.Group
                              className="col-md-2 my-3"
                              controlId="exampleForm.c_email"
                            >
                              <div class="checkbox-item">
                                <input
                                  type="checkbox"
                                  class="custom-checkbox"
                                  checked={
                                    formik.values.display_on_trends === 1
                                      ? true
                                      : false
                                  }
                                  onChange={(p) => {
                                    if (p.target.checked) {
                                      formik.setFieldValue(
                                        "display_on_trends",
                                        parseInt("1")
                                      );
                                    } else {
                                      formik.setFieldValue(
                                        "display_on_trends",
                                        parseInt("0")
                                      );
                                    }
                                  }}
                                />
                                Display On Trends
                              </div>
                              {/* <ErrorMessage
                              name="customer_address"
                              component={Texterror}
                            /> */}
                            </Form.Group>

                            <Form.Group className="col-md-12 mb-3 d-flex justify-content-end">
                              {/* <Button
                              variant="primary"
                              type="button"
                              onClick={() => {
                                formik.resetForm();
                                setSelectedImage(null);
                                // const fileInput =
                                //   document.getElementById("logo");
                                // if (fileInput) {
                                //   fileInput.value = "";
                                // }
                              }}
                            >
                              Reset
                            </Button> */}
                              <Button
                                className="ms-3"
                                variant="success"
                                type="submit"
                                disabled={isLoading}
                              >
                                {isLoading ? "Saving..." : "Save"}
                              </Button>
                            </Form.Group>
                          </div>
                        </FormikForm>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Formik>
      ) : (
        <div className="d-flex align-items-center justify-content-center w-100vw h-100vh">
          <span class="loader" style={{ width: "50px", height: "50px" }}></span>
        </div>
      )}
    </>
  );
}

export default EditFacilityForm;
